import React from 'react';


export default function LinkolnEmail(props) {
  return (
    <tr>
        <td>{ props.linkoln_email.url }</td>
        <td><a target="_blank" rel="noreferrer" href={ props.linkoln_email.preview_url }>Preview</a></td>
    </tr>
  );
}
